$('.js-load-more').on('click', function(){
  const $this =$(this);
  const totalPages = parseInt($('[data-total-pages]').val());
  let currentPage = parseInt($('[data-current-page]').val());
  
  $this.attr('disabled', true);
  $this.addClass('loading');
  currentPage = currentPage+1;
  const nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);

  $('[data-current-page]').val(currentPage);
  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      $('.load-more-grid').append($(responseHTML).find('.load-more-grid').html());
    },
    complete: function() {
      if(currentPage <= totalPages) {
         $this.attr('disabled', false);
         $this.removeClass('loading');
         if (currentPage == totalPages) {
          $this.remove();
         }
      } 
    }
  })
});